import HotelDetails from '@customTypes/hotel-details';
import React from 'react';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import styles from './MobileHotelDetails.module.css';

type Props = {
  hotel: HotelDetails;
};

export default function PoolHours({ hotel }: Props) {
  return (
    <div
      data-testid="pool-hours-section"
      className="border-b-8 border-rp-gray-divider mt-8 pb-12 px-4"
    >
      <p className="font-rp-gelica-light leading-26px text-22 text-rp-primary-black">Hours</p>

      <div className={`${styles.poolHours} mt-6`}>
        <ReactMarkdown>{hotel.metadata.markdown_pool_hours_details}</ReactMarkdown>
      </div>
    </div>
  );
}
